import { render, staticRenderFns } from "./SkupSuorganizatorEdit.vue?vue&type=template&id=a1772900&scoped=true&"
import script from "./SkupSuorganizatorEdit.vue?vue&type=script&lang=js&"
export * from "./SkupSuorganizatorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1772900",
  null
  
)

export default component.exports